// extracted by mini-css-extract-plugin
export default {"component":"Card_component__H4xuj","dark":"Card_dark__hMWb1","header":"Card_header__jms0l","body":"Card_body__r9YJS","footer":"Card_footer__PKn7-"};